import { createInitial } from '../../util';
import { M_PER_NEW_01_Schema } from '../PermitNew/M_PER_NEW/M_PER_NEW_01/M_PER_NEW_01_Schema';
import { M_PER_CUSTOM_01_Schema } from './M_PER_CUSTOM/M_PER_CUSTOM_01/M_PER_CUSTOM_01_Schema';

export const PERMIT_INITIAL_DATA = {
  CUSTOM: {
    baseInfo: createInitial(M_PER_CUSTOM_01_Schema.fields.baseInfo),
    codeInfo: createInitial(M_PER_CUSTOM_01_Schema.fields.codeInfo),
  },
  NEW: {
    baseInfo: createInitial(M_PER_NEW_01_Schema.fields.baseInfo),
    codeInfo: createInitial(M_PER_NEW_01_Schema.fields.codeInfo),
  },
};
